"use client";

import { SidebarLiquidRail } from "components/ui/v2/sidebar/sidebar-liquid-rail";
import { useRouter } from "next/router";
import React, { useCallback } from "react";
import { useMobileSidebarStore } from "stores/sidebar/useMobileSidebarStore";
import { useSidebarNavigation } from "./use-sidebar-navigation";

export interface SidebarProps {
  render?: boolean;
}

export const Sidebar = React.memo(function Sidebar({ render = true }: SidebarProps) {
  const router = useRouter();
  const { primaryRailItems } = useSidebarNavigation();
  const { closeBurgerSidebar } = useMobileSidebarStore();
  const isCurrentPath = useCallback(
    (path: string) => router.pathname === path || router.pathname.startsWith(path),
    [router.pathname]
  );

  const handleNavigation = useCallback(
    (path: string) => {
      closeBurgerSidebar();
      void router.push(path);
    },
    [router, closeBurgerSidebar]
  );

  if (!render) return null;

  return (
    <aside
      className="sidebar-v2-rail pointer-events-none relative z-[6000] flex h-full w-[var(--sidebar-width-collapsed)] min-w-[var(--sidebar-width-collapsed)] flex-col items-center justify-center overflow-visible bg-transparent"
      aria-label="Navegación lateral"
    >
      <div className="sidebar-v2-rail-scroll pointer-events-auto min-h-0 flex-1 py-2 pr-0.5">
        <SidebarLiquidRail
          items={primaryRailItems}
          isCurrentPath={isCurrentPath}
          onNavigate={handleNavigation}
          expandTo="right"
        />
      </div>

      <style jsx global>{`
        .sidebar-v2-rail {
          height: 100%;
        }

        @media (min-width: 769px) {
          .sidebar-v2-rail {
            height: 100%;
          }
        }

        #sidebar-v2 {
          position: relative;
          top: 0;
          z-index: 10050;
          overflow: visible;
          width: var(--sidebar-width-collapsed);
          min-width: var(--sidebar-width-collapsed);
        }

        #sidebar-v2 .sidebar-v2-rail {
          overflow: visible;
        }

        #sidebar-v2 .sidebar-v2-rail-scroll {
          width: 100%;
          max-height: 100%;
          overflow: visible;
          /* El rail se mueve con translateY para simular scroll. Como el sidebar
             ahora es fixed, necesitamos recortar verticalmente para que los
             botones no invadan navbar/header, pero dejar espacio horizontal para
             labels/submenús expandidos. */
          clip-path: inset(0 -360px 0 -360px);
        }
      `}</style>
    </aside>
  );
});
